import {
  MSG_DELETE_WARNING,
  MSG_UNDO_DELETE_WARNING,
  MSG_RECORD_CREATE,
  MSG_RECORD_UPDATE,
  MSG_RECORD_DELETE,
  MSG_RECORD_UNDO,
  MIN_TEXT_LENGTH,
  MAX_TEXT_LENGTH,
} from "constants/common";

// HIS_RELEASE_VERSION Type

export const METHOD_HIS_RELEASE_VERSION_LIST =
  "hisreleaseversion/pageable/";
export const METHOD_HIS_RELEASE_VERSION_CREATE = "hisreleaseversion/";
export const METHOD_HIS_RELEASE_VERSION_UPDATE =
  "hisreleaseversion/{ID}/";
export const METHOD_HIS_RELEASE_VERSION_DELETE =
  "hisreleaseversion/{ID}/";
export const METHOD_HIS_RELEASE_VERSION_DETAIL =
  "hisreleaseversion/{ID}/";
// cpu generation
export const METHOD_CPU_GEN_MAPPING_KEY_CREATE = "hismapper/5/0/";
export const METHOD_CPU_GEN_MAPPING_KEY_DETAILS = "hismapper/5/{ID}/";
export const METHOD_CPU_GEN_MAPPING_KEY_UPDATE = "hismapper/5/{ID}/";
export const METHOD_CPU_GEN_MAPPING_KEY_DELETE = "hismapper/5/{ID}/0/";

// cpld
export const METHOD_CPLD_MAPPING_KEY_CREATE = "hismapper/4/0/";
export const METHOD_CPLD_MAPPING_KEY_DETAILS = "hismapper/4/{ID}/";
export const METHOD_CPLD_MAPPING_KEY_UPDATE = "hismapper/4/{ID}/";
export const METHOD_CPLD_MAPPING_KEY_DELETE = "hismapper/4/{ID}/0/";

// bios bmc
export const METHOD_BIOS_MAPPING_KEY_CREATE = 'hismapper/17/0/';
export const METHOD_BIOS_MAPPING_KEY_DETAILS = 'hismapper/17/{ID}/';
export const METHOD_BIOS_MAPPING_KEY_DELETE= 'hismapper/17/{ID}/0';

// nic
export const METHOD_NIC_MAPPING_KEY_CREATE = 'hismapper/13/0/';
export const METHOD_NIC_MAPPING_KEY_DETAILS = 'hismapper/13/{ID}/';
export const METHOD_NIC_MAPPING_KEY_DELETE= 'hismapper/13/{ID}/0';


// hba
export const METHOD_HBA_MAPPING_KEY_CREATE = "hismapper/10/0/";
export const METHOD_HBA_MAPPING_KEY_DETAILS = "hismapper/10/{ID}/";
export const METHOD_HBA_MAPPING_KEY_UPDATE = "hismapper/10/{ID}/";
export const METHOD_HBA_MAPPING_KEY_DELETE = "hismapper/10/{ID}/0/";

// controller
export const METHOD_CONTROLLER_MAPPING_KEY_CREATE = "hismapper/3/0/";
export const METHOD_CONTROLLER_MAPPING_KEY_DETAILS = "hismapper/3/{ID}/";
export const METHOD_CONTROLLER_MAPPING_KEY_UPDATE = "hismapper/3/{ID}/";
export const METHOD_CONTROLLER_MAPPING_KEY_DELETE = "hismapper/3/{ID}/0/";

// gpu
export const METHOD_GPU_MAPPING_KEY_CREATE = "hismapper/9/0/";
export const METHOD_GPU_MAPPING_KEY_DETAILS = "hismapper/9/{ID}/";
export const METHOD_GPU_MAPPING_KEY_DELETE = "hismapper/9/{ID}/0";


// fc switch
export const METHOD_FC_SWITCH_MAPPING_KEY_CREATE = "hismapper/8/0/";
export const METHOD_FC_SWITCH_MAPPING_KEY_DETAILS = "hismapper/8/{ID}/";
export const METHOD_FC_SWITCH_MAPPING_KEY_DELETE = "hismapper/8/{ID}/0";

// leaf switch
export const METHOD_LEAF_SWITCH_MAPPING_KEY_CREATE = "hismapper/11/0/";
export const METHOD_LEAF_SWITCH_MAPPING_KEY_DETAILS = "hismapper/11/{ID}/";
export const METHOD_LEAF_SWITCH_MAPPING_KEY_DELETE = "hismapper/11/{ID}/0";

// spine switch
export const METHOD_SPINE_SWITCH_MAPPING_KEY_CREATE = "hismapper/16/0/";
export const METHOD_SPINE_SWITCH_MAPPING_KEY_DETAILS = "hismapper/16/{ID}/";
export const METHOD_SPINE_SWITCH_MAPPING_KEY_DELETE = "hismapper/16/{ID}/0";

// management switch
export const METHOD_MANAGEMENT_SWITCH_MAPPING_KEY_CREATE = "hismapper/12/0/";
export const METHOD_MANAGEMENT_SWITCH_MAPPING_KEY_DETAILS ="hismapper/12/{ID}/";
export const METHOD_MANAGEMENT_SWITCH_MAPPING_KEY_DELETE ="hismapper/12/{ID}/0";

// drive
export const METHOD_DRIVE_MAPPING_KEY_CREATE = "hismapper/6/0/";
export const METHOD_DRIVE_MAPPING_KEY_DETAILS = "hismapper/6/{ID}/";
export const METHOD_DRIVE_MAPPING_KEY_UPDATE = "hismapper/6/{ID}/";
export const METHOD_DRIVE_MAPPING_KEY_DELETE = "hismapper/6/{ID}/0/";

// switch firmware
export const METHOD_FIRMWARE_BY_SWITCH ="hismapper/switchfirmware/{product_id}/{switch_id}/";

// block storage
export const METHOD_BLOCK_STORAGE_MAPPING_KEY_CREATE = "hismapper/2/0/";
export const METHOD_BLOCK_STORAGE_MAPPING_KEY_DETAILS = "hismapper/2/{ID}/";
export const METHOD_BLOCK_STORAGE_MAPPING_KEY_UPDATE = "hismapper/2/{ID}/";
export const METHOD_BLOCK_STORAGE_MAPPING_KEY_DELETE = "hismapper/2/{ID}/0/";

// extra
export const METHOD_EXTRA_MAPPING_KEY_CREATE = 'hismapper/7/0/';
export const METHOD_EXTRA_MAPPING_KEY_DETAILS = 'hismapper/7/{ID}/';
export const METHOD_EXTRA_MAPPING_KEY_DELETE= 'hismapper/7/{ID}/0';
export const METHOD_EXTRA_MAPPING_KEY_UPDATE = "hismapper/7/{ID}/";
//text box length
export const TEXT_MIN_LENGTH = MIN_TEXT_LENGTH;
export const TEXT_MAX_LENGTH = MAX_TEXT_LENGTH;

//language constants
export const MSG_WARNING_DELETE = MSG_DELETE_WARNING;
export const MSG_WARNING_UNDO_DELETE = MSG_UNDO_DELETE_WARNING;
export const MSG_CREATE_RECORD = MSG_RECORD_CREATE;
export const MSG_UPDATE_RECORD = MSG_RECORD_UPDATE;
export const MSG_DELETE_RECORD = MSG_RECORD_DELETE;
export const MSG_UNDO_RECORD = MSG_RECORD_UNDO;

// MASTER MAPPING
export const METHOD_HISMAPPER_LIST = "hismapperlist/{masterId}/";
export const METHOD_HIS_COMBINE_KEY_CREATE = "hismapper/1/0/";
export const METHOD_HIS_COMBINE_KEY_DELETE = "hismapper/1/{ID}/0/";
// generic error template

export const MSG_COMBINE_KEY_WARNING =
  "Please select at least one combine key from the dropdown!";
export const MSG_MAPPING_DELETE_WARNING = "Are you sure you want to remove ";
export const MSG_MAPPING_RESTORE_WARNING = "Are you sure you want to restore ";
export const MAPPING_SELECT_ERROR_TEMPLATE = "Please select _FIELD_NAME_!";
export const MAPPING_INPUT_ERROR_TEMPLATE = "Please enter _FIELD_NAME_!";